import React from "react";
import TablePlanItem from "./TablePlan-Item";
import { useAppContext } from "../../context/appContext";

const TablePlanModal = () => {
    const { selectTable, basket } = useAppContext();

    const selectTableHandler = ($id) => {
        selectTable($id, "select");
    };

    return (
        <div className={"modal flex " + (basket.tableNum !== null ? "hidden" : "")}>
            <div className='container h-[700px] w-[1300px] bg-main-700'>
                <TablePlanItem
                    onAction={selectTableHandler}
                    nameTag={"Bar"}
                    tableName={"Bar"}
                    specialClasses={"bg-main-100 w-full h-full text-black"}
                />
                <TablePlanItem
                    onAction={selectTableHandler}
                    id={1}
                    nameTag={"Table 1"}
                    tableName={"Table-1"}
                    specialClasses={"bg-main-100 w-1/2 h-1/2 text-black "}
                />
                <TablePlanItem
                    onAction={selectTableHandler}
                    id={2}
                    nameTag={"Table 2"}
                    tableName={"Table-2"}
                    specialClasses={"bg-main-100 w-1/2 h-1/2 text-black "}
                />
                <TablePlanItem
                    onAction={selectTableHandler}
                    id={3}
                    nameTag={"Table 3"}
                    tableName={"Table-3"}
                    specialClasses={"bg-main-100 w-1/2 h-1/2 text-black "}
                />
                <TablePlanItem
                    onAction={selectTableHandler}
                    id={4}
                    nameTag={"Table 4"}
                    tableName={"Table-4"}
                    specialClasses={"bg-main-100 w-1/2 h-1/2 text-black "}
                />
                <TablePlanItem
                    onAction={selectTableHandler}
                    id={5}
                    nameTag={"Table 5"}
                    tableName={"Table-5"}
                    specialClasses={"bg-main-100 w-1/2 h-1/2 text-black "}
                />
                <TablePlanItem
                    onAction={selectTableHandler}
                    id={6}
                    nameTag={"Table 6"}
                    tableName={"Table-6"}
                    specialClasses={"bg-main-100 w-1/2 h-1/2 text-black "}
                />
                <TablePlanItem
                    onAction={selectTableHandler}
                    id={7}
                    nameTag={"Table 7"}
                    tableName={"Table-7"}
                    specialClasses={"bg-main-100 w-1/2 h-1/2 text-black "}
                />
                <TablePlanItem
                    onAction={selectTableHandler}
                    id={8}
                    nameTag={"Table 8"}
                    tableName={"Table-8"}
                    specialClasses={"bg-main-100 w-1/2 h-1/2 text-black "}
                />
                <TablePlanItem
                    onAction={selectTableHandler}
                    id={9}
                    nameTag={"Table 9"}
                    tableName={"Table-9"}
                    specialClasses={"bg-main-100 w-1/2 h-1/2 text-black "}
                />
                <TablePlanItem
                    onAction={selectTableHandler}
                    id={10}
                    nameTag={"Table 10"}
                    tableName={"Table-10"}
                    specialClasses={"bg-main-100 w-1/2 h-1/2 text-black "}
                />
            </div>
        </div>
    );
};

export default TablePlanModal;
